"use strict";
// See: https://blog.mgechev.com/2015/02/06/parsing-binary-protocol-data-javascript-typedarrays-blobs/#:~:text=The%20two%20possible%20values%20for,is%20the%20blob%20binary%20type.
Object.defineProperty(exports, "__esModule", { value: true });
exports.process = exports.registerAll = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var diveMessage_gameSync_sidecar_1 = require("./diveMessage_gameSync-sidecar");
var diveMessage_hostCommand_sidecar_1 = require("./diveMessage_hostCommand-sidecar");
var diveMessage_loadState_sidecar_1 = require("./diveMessage_loadState-sidecar");
var diveMessage_mouseInput_sidecar_1 = require("./diveMessage_mouseInput-sidecar");
var diveMessage_simulationFrame_sidecar_1 = require("./diveMessage_simulationFrame-sidecar");
var diveMessage_simulationSync_sidecar_1 = require("./diveMessage_simulationSync-sidecar");
var voyageMessageBulletCreate_sidecar_1 = require("./voyageMessageBulletCreate-sidecar");
var voyageMessageBuyRequest_sidecar_1 = require("./voyageMessageBuyRequest-sidecar");
var voyageMessageCrewCarry_sidecar_1 = require("./voyageMessageCrewCarry-sidecar");
var voyageMessageCrewCreate_sidecar_1 = require("./voyageMessageCrewCreate-sidecar");
var voyageMessageCrewHurt_sidecar_1 = require("./voyageMessageCrewHurt-sidecar");
var voyageMessageCrewHurtEnergy_sidecar_1 = require("./voyageMessageCrewHurtEnergy-sidecar");
var voyageMessageCrewMove_sidecar_1 = require("./voyageMessageCrewMove-sidecar");
var voyageMessageCrewSelected_sidecar_1 = require("./voyageMessageCrewSelected-sidecar");
var voyageMessageCrewStyle_sidecar_1 = require("./voyageMessageCrewStyle-sidecar");
var voyageMessageCursor_sidecar_1 = require("./voyageMessageCursor-sidecar");
var voyageMessageEffectCommand_sidecar_1 = require("./voyageMessageEffectCommand-sidecar");
var voyageMessageEnemyShipCommand_sidecar_1 = require("./voyageMessageEnemyShipCommand-sidecar");
var voyageMessageGeneralCommand_sidecar_1 = require("./voyageMessageGeneralCommand-sidecar");
var voyageMessageHostCommand_sidecar_1 = require("./voyageMessageHostCommand-sidecar");
var voyageMessageInfoRequest_sidecar_1 = require("./voyageMessageInfoRequest-sidecar");
var voyageMessageInfoSend_sidecar_1 = require("./voyageMessageInfoSend-sidecar");
var voyageMessageJettison_sidecar_1 = require("./voyageMessageJettison-sidecar");
var voyageMessageJump_sidecar_1 = require("./voyageMessageJump-sidecar");
var voyageMessageLoadShip_sidecar_1 = require("./voyageMessageLoadShip-sidecar");
var voyageMessageMoney_sidecar_1 = require("./voyageMessageMoney-sidecar");
var voyageMessageRequestGamestate_sidecar_1 = require("./voyageMessageRequestGamestate-sidecar");
var voyageMessageShipStatus_sidecar_1 = require("./voyageMessageShipStatus-sidecar");
var voyageMessageStarmapCreate_sidecar_1 = require("./voyageMessageStarmapCreate-sidecar");
var voyageMessageSystemCreate_sidecar_1 = require("./voyageMessageSystemCreate-sidecar");
var voyageMessageWeaponCommand_sidecar_1 = require("./voyageMessageWeaponCommand-sidecar");
var diveMessage_alterEntity_sidecar_1 = require("./diveMessage_alterEntity-sidecar");
var crokinole_cursor_sidecar_1 = require("@crokinole/multi/crokinole_cursor-sidecar");
var crokinole_gameSync_sidecar_1 = require("@crokinole/multi/crokinole_gameSync-sidecar");
var crokinole_input_sidecar_1 = require("@crokinole/multi/crokinole_input-sidecar");
var crokinole_simulationFrame_sidecar_1 = require("@crokinole/multi/crokinole_simulationFrame-sidecar");
var crokinole_gameDrift_sidecar_1 = require("@crokinole/multi/crokinole_gameDrift-sidecar");
var _map = {};
var _list = [];
function registerAll() {
    register(voyageMessageEffectCommand_sidecar_1.voyageMessageEffectCommand);
    register(voyageMessageCrewCreate_sidecar_1.voyageMessageCrewCreate);
    register(voyageMessageCrewCarry_sidecar_1.voyageMessageCrewCarry);
    register(voyageMessageShipStatus_sidecar_1.voyageMessageShipStatus);
    register(voyageMessageHostCommand_sidecar_1.voyageMessageHostCommand);
    register(voyageMessageEnemyShipCommand_sidecar_1.voyageMessageEnemyShipCommand);
    register(voyageMessageGeneralCommand_sidecar_1.voyageMessageGeneralCommand);
    register(voyageMessageCrewMove_sidecar_1.voyageMessageCrewMove);
    register(voyageMessageCrewSelected_sidecar_1.voyageMessageCrewSelected);
    register(voyageMessageCursor_sidecar_1.voyageMessageCursor);
    register(voyageMessageBulletCreate_sidecar_1.voyageMessageBulletCreate);
    register(voyageMessageCrewHurt_sidecar_1.voyageMessageCrewHurt);
    register(voyageMessageInfoRequest_sidecar_1.voyageMessageInfoRequest);
    register(voyageMessageInfoSend_sidecar_1.voyageMessageInfoSend);
    register(voyageMessageWeaponCommand_sidecar_1.voyageMessageWeaponCommand);
    register(voyageMessageSystemCreate_sidecar_1.voyageMessageSystemCreate);
    register(voyageMessageCrewHurtEnergy_sidecar_1.voyageMessageCrewHurtEnergy);
    register(voyageMessageBuyRequest_sidecar_1.voyageMessageBuyRequest);
    register(voyageMessageJettison_sidecar_1.voyageMessageJettison);
    register(voyageMessageJump_sidecar_1.voyageMessageJump);
    register(voyageMessageMoney_sidecar_1.voyageMessageMoney);
    register(voyageMessageCrewStyle_sidecar_1.voyageMessageCrewStyle);
    register(voyageMessageStarmapCreate_sidecar_1.voyageMessageStarmapCreate);
    register(voyageMessageRequestGamestate_sidecar_1.voyageMessageRequestGamestate);
    register(voyageMessageLoadShip_sidecar_1.voyageMessageLoadShip);
    register(diveMessage_gameSync_sidecar_1.diveMessage_gameSync);
    register(diveMessage_simulationFrame_sidecar_1.diveMessage_simulationFrame);
    register(diveMessage_simulationSync_sidecar_1.diveMessage_simulationSync);
    register(diveMessage_loadState_sidecar_1.diveMessage_loadState);
    register(diveMessage_mouseInput_sidecar_1.diveMessage_mouseInput);
    register(diveMessage_hostCommand_sidecar_1.diveMessage_hostCommand);
    register(diveMessage_alterEntity_sidecar_1.diveMessage_alterEntity);
    register(crokinole_cursor_sidecar_1.crokinole_cursor);
    register(crokinole_gameSync_sidecar_1.crokinole_gameSync);
    register(crokinole_input_sidecar_1.crokinole_input);
    register(crokinole_simulationFrame_sidecar_1.crokinole_simulationFrame);
    register(crokinole_gameDrift_sidecar_1.crokinole_gameDrift);
}
exports.registerAll = registerAll;
function register(mh) {
    assert_sidecar_1.assert.nil(_map[mh.voyageMessageId], 'voyageMessage handler', mh.voyageMessageId);
    _map[mh.voyageMessageId] = mh;
    _list.push(mh);
    // Test it!
    mh.test();
}
function process(m, skipFrom) {
    // console.log('process voyageMessage')
    if (skipFrom === void 0) { skipFrom = false; }
    // TODO: move some of this to engine?
    var from = -1;
    if (!skipFrom) {
        var fromB1 = messageWriter_sidecar_1.messageWriter.readU8(m);
        var fromB2 = messageWriter_sidecar_1.messageWriter.readU8(m);
        from = fromB1 + (fromB2 << 8);
    }
    // Check if this is from the host
    var isFromHost = from === -1 || from === websockets_sidecar_1.websockets.getHostId();
    var t = messageWriter_sidecar_1.messageWriter.peek8(m);
    var handler = _map[t];
    if (handler) {
        handler.process(m, isFromHost, from);
    }
    else {
        var t1 = messageWriter_sidecar_1.messageWriter.read16(m);
        var t2 = messageWriter_sidecar_1.messageWriter.read8(m);
        assert_sidecar_1.assert.failed('unknown voyageMessage type', t, t1, t2);
    }
}
exports.process = process;
